<!-- eslint-disable vue/valid-v-slot -->
<template>
<v-container max-width="800">
    <v-card class="pa-2 align-center justify-center">
        <v-card-title>Settings</v-card-title>

        <v-form ref="preferencesForm" lazy-validation>
        <v-layout cols="12" md12 lg8 offset-lg2 xl6 offset-xl3 row>
            <!-- <v-flex xs12 sm6 lg4>
            <v-card class="mx-5 my-4 pa-4">
                <v-card-title>Unit of Measure:</v-card-title>
                <v-card-text>

                <v-select
                    :items="units"
                    v-model="metric"
                    item-text="name"
                    item-value="value"
                />
                </v-card-text>
            </v-card>
            </v-flex> -->
            <v-flex xs12 sm12 lg12>
                <!-- <v-card-title>
                Notifications
                </v-card-title>
                <v-card-subtitle>
                {{ user.user.notif_allowed == 1 ? "You are currently subscribed to Competition Notifications" : "You are not currently subscribed to Competition Notifications" }}
                </v-card-subtitle>
                <v-btn @click="allow_notifications">Notification Setting</v-btn> -->
                <!-- <v-card-text>{{ notifKey }}</v-card-text> -->
                <v-card-text><NotificationPage/></v-card-text>
            </v-flex>
            <v-spacer />
            <v-alert v-if="infoMessage !== ''" type="info">
                <span v-html="infoMessage" />
            </v-alert>
        </v-layout>
        <div v-if="user.status >= 7">
            <v-card-text class="px-4">
                <v-card-title class="px-0">Admin Controls</v-card-title>

                <v-row class="align-center">
                    <v-col cols="12" >
                        <div class="px-0 text-title-large">Download Classification Data</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-date-input v-model="rangeImage" label="Select Range" multiple="range" variant="solo-filled" @update:modelValue="downloadImageData" hide-details></v-date-input>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex justify-center align-center">
                        <JsonCSV
                            :data="jsonImageData"
                            :name="filenameImage">
                            <v-btn
                                class="rounded-xl white--text px-6" color="#1ac266"
                                :disabled="Object.keys(jsonImageData).length === 0">
                                Download .CSV {{ resultsImage != null ? '(' + resultsImage + ' results)' : '' }}
                            </v-btn>
                        </JsonCSV>
                    </v-col>

                    <v-col cols="12" >
                        <div class="px-0 text-title-large">Download Survey Data</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-date-input v-model="rangeSurvey" label="Select Range" multiple="range" @update:modelValue="downloadSurveyData" hide-details></v-date-input>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex justify-center align-center">
                        <JsonCSV
                            :data="jsonSurveyData"
                            :name="filenameSurvey">
                            <v-btn
                                class="rounded-xl white--text px-6" color="#1ac266"
                                :disabled="Object.keys(jsonSurveyData).length === 0">
                                Download .CSV {{ resultsSurvey != null ? '(' + resultsSurvey + ' results)' : '' }}
                            </v-btn>
                        </JsonCSV>
                    </v-col>
                </v-row>
            </v-card-text>
        </div>
        <v-divider class="my-4"></v-divider>

        <v-select
            :items="row_numbers"
            v-model="selected_row_number"
            label="Results of each tier"
            @update:modelValue="rowNumbersChanged()"
            class="mr-14 ml-14 mt-6"
        ></v-select>

          <v-data-table
            :headers="headers"
            :items="tempData"
            @click:row="openDialog"
            item-key="name"
        >
            <template v-slot:item.image_name="{ value }">
                <v-img
                    :src="'https://aurorafinder.app/api/aurora_image/' + value"
                ></v-img>
            </template>

        </v-data-table>
        <v-dialog v-model="dialog" max-width="800">
            <v-card v-if="selectedData != null">
                <v-card-title>{{ selectedData.image_name }}</v-card-title>
                <v-img
                    :src="'https://aurorafinder.app/api/aurora_image/' + selectedData.image_name"
                ></v-img>
                <v-card-text>
                    <div><strong>Image Name:</strong> {{ selectedData.image_name }}</div>
                    <div><strong>Date Received:</strong> {{ selectedData.date_recieved }}</div>
                    <div><strong>Predicted Tier:</strong> {{ convertTier(selectedData.tier) }} - {{ selectedData.tier }}</div>
                    <div><strong>User Tier:</strong> {{ selectedData.user_tier ? convertTier(selectedData.user_tier) : '' }}</div>
                </v-card-text>
                <v-card-actions>
                    <v-select
                        :items="user_tiers"
                        v-model="selected_user_tier"
                        density="compact"
                        label="tier"
                        item-title="tier"
                        item-value="id"
                    ></v-select>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="#1ac266" class="white--text rounded-xl ml-8 mr-4" @click="saveUserTier">save user tier</v-btn>
                    <v-btn color="red" class="white--text rounded-xl mr-4 ml-8" @click="dialog = false">Close</v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
        </v-form>
    </v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import NotificationPage from './NotificationPage.vue'
import { VDateInput } from 'vuetify/labs/VDateInput'
import JsonCSV from 'vue-json-csv'
import { useMainStore } from '@/store/store';
import { mapState, mapWritableState } from 'pinia';
import { toRaw, nextTick } from "vue";

// import axios from 'axios'
// import { VDateInput } from 'vuetify/labs/VDateInput'
// import JsonCSV from 'vue-json-csv'
// import { mainStore } from '../store.js '
// const store = mainStore();

export default {
    setup() {
        const store = useMainStore()
        
        // function setAccess(value){
        //   userAccessLevel.value = value
        // }

        return { 
            store,
        }
    },
    name: 'SettingsPage',

    components: {
        NotificationPage,
        VDateInput,
        JsonCSV,

    },
    computed: {
        ...mapState(useMainStore, {
            user: store => store.user,
            isLoggedIn: store => store.isLoggedIn,
            results_data: store => store.results_data,
        }),
        ...mapWritableState(useMainStore, {

        }),
    },

    data: () => ({
        errorMessage: '',
        infoMessage: '',
        toRawUser: [],
        selected_user_tier: null,

        rangeImage: null,
        jsonImageData: [],
        filenameImage: "",
        resultsImage: null,

        rangeSurvey: null,
        jsonSurveyData: [],
        filenameSurvey: "",
        resultsSurvey: null,
        
        tempData: [
            {
                id: 33535,
                image_name: "frame_20260419_073759.jpg",
                date_recieved: "2026-04-19 07:38:04",
                tier: "3",
                user_tier: "",
            },
            {
                id: 33534,
                image_name: "frame_20260419_073554.jpg",
                date_received: "2026-04-19 07:35:59",
                tier: "3",
                user_tier: "",
            },
        ],

        headers: [
            { title: 'ID', align: 'start', sortable: false, key: 'id' },
            { title: 'Image', align: 'end', key: 'image_name' },
            { title: 'Date', align: 'end', key: 'date_received' },
            { title: 'Predicted Tier', align: 'end', key: 'tier' },
            { title: 'User Tier', align: 'end', key: 'user_tier' },
        ], 

        dialog: false,
        selectedItem: null,
        selectedData: null,
        selected_row_number: 25,

        user_tiers: [
            {
                id: 0,
                tier: "No Aurora",
            },
            {
                id: 1,
                tier: "Subdued",
            },
            {
                id: 2,
                tier: "Engaging",
            },
            {
                id: 3,
                tier: "Vivid",
            },
            {
                id: 4,
                tier: "Brilliant",
            },
            {
                id: -1,
                tier: "Cloud Obstructions",
            },
            {
                id: -2,
                tier: "Cloud Obstructions With Aurora",
            },
            {
                id: -3,
                tier: "Light Contamination",
            },
            {
                id: -4,
                tier: "False Positive",
            },
        ],
        row_numbers: [5, 10, 25, 50, 100],
    }),

    methods: {
        convertTier(tier) {
            switch(tier) {
                case "0":
                    return "No Aurora"
                case "1":
                    return "Subdued"
                case "2":
                    return "Engaging"
                case "3":
                    return "Vivid"
                case "4":
                    return "Brilliant"
                case "-1":
                    return "Cloud Obstructions"
                case "-2":
                    return "Cloud Obstructions With Aurora"
                case "-3":
                    return "Light Contamination"
                case "-4":
                    return "False Positive"
            }
        },
        openDialog(e, {item}){
            // console.log(item)
            // console.log(item.id)
            this.selected_user_tier = null
            this.selectedItem = item.id
            this.selectedData = item
            this.dialog = true
        },
        saveUserTier(){
            let data = {
                id: this.selectedData.id,
                image_name: this.selectedData.image_name,
                user_tier: this.selected_user_tier,
            }

            axios.put('save_user_tier', data)
            .then(() => {
                this.dialog = false
                this.selected_user_tier = null
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })

        },
        async rowNumbersChanged(){
            // console.log(this.selected_row_number)
            await this.store.getResultsData(this.selected_row_number)
            .then(() => {
                this.tempData = this.results_data
            })
        },
        downloadImageData() {
            this.jsonImageData = []
            this.resultsImage = null
            let startDateImage = this.rangeImage[0].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            let endDateImage = this.rangeImage[this.rangeImage.length-1].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            this.filenameImage = "ImageData - " + startDateImage + " to " + endDateImage + ".csv"
            
            let data = {
                startDate: startDateImage,
                endDate: endDateImage,
            }

            axios.post('image_data', data)
            .then((resp) => {
                if (resp.data != null) {
                    this.jsonImageData = JSON.parse(JSON.stringify(resp.data))

                    // Convert numerical value of tier
                    for (var i = 0; i < this.jsonImageData.length; i++) { this.jsonImageData[i].tier = this.convertTier(this.jsonImageData[i].tier) }

                    this.resultsImage = resp.data.length
                }
                else {
                    this.resultsImage = 0
                }
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        },
        downloadSurveyData() {
            this.jsonSurveyData = []
            this.resultsSurvey = null
            let startDateSurvey = this.rangeSurvey[0].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            let endDateSurvey = this.rangeSurvey[this.rangeSurvey.length-1].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            this.filenameSurvey = "SurveyData - " + startDateSurvey + " to " + endDateSurvey + ".csv"
            
            let data = {
                startDate: startDateSurvey,
                endDate: endDateSurvey,
            }

            axios.post('survey_data', data)
            .then((resp) => {
                if (resp.data != null) {
                    this.jsonSurveyData = JSON.parse(JSON.stringify(resp.data))

                    // Convert numerical value of tier
                    for (var i = 0; i < this.jsonSurveyData.length; i++) { this.jsonSurveyData[i].tier = this.convertTier(this.jsonSurveyData[i].tier) }

                    this.resultsSurvey = resp.data.length
                }
                else {
                    this.resultsSurvey= 0
                }
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        },
    },
    async mounted(){
        // check the user account to see if notifications are allowed and set that value
        this.toRawUser = toRaw(this.user)
        await nextTick()
        // // this.notif_allowed = this.toRawUser.notif_allowed
        await this.store.getResultsData(25)
        // await this.store.getResultsData()
        .then(() => {
            this.tempData = this.results_data
        })
        // console.log(this.toRawUser)
    },
}
</script>

<style scoped>
.v-btn--disabled {
  background-color: rgba(255, 255, 255, 0.12) !important;
  color: rgba(255, 255, 255, 0.3) !important;
}
</style>
